//EXTERNAL
import React from "react"
import { useLocation } from "react-router-dom"
//COMPONENTS
import Header from "../../../components/Header"
import Post from "../../../components/Post"
import HelloArticle from "../../../components/Article/Hello"
//ASSETS
import "./Hello.css"
import HelloLogo from "../../../assets/hello-logo.png"
//FUNCTIONS

export default function Hello({ isDesktop }) {
  const studioV1Bucket = "https://picnic-studio-production-creativesbucket-7202zhypcuax.s3-eu-west-1.amazonaws.com/public"
  const studioV2Bucket = "https://studio-creatives-prod.s3-eu-west-2.amazonaws.com/public"

  const location = useLocation()
  const pathname = location.pathname.split("/")
  const origin = pathname[1]
  const format = pathname[2]
  const teamId = pathname[3]
  const creativeId = pathname[4]

  function buildFormat() {
    if (format === "post") {
      return <Post path={buildPath()} id={creativeId} />
    }
  }

  function buildPath() {
    if (origin === "studio") return `${studioV1Bucket}/${teamId}/${creativeId}/index.html`
    if (origin === "v2") return `${studioV2Bucket}/${teamId}/${creativeId}/index.min.html`
  }

  return (
    <div id="article-container-hello">
      {isDesktop ? <Header Logo={HelloLogo} /> : null}
      <HelloArticle isDesktop={isDesktop} format={buildFormat()} />
    </div>
  )
}
